export var NotificationCategory;
(function (NotificationCategory) {
    NotificationCategory["TASK"] = "task";
    NotificationCategory["MEETING"] = "meeting";
    NotificationCategory["MESSAGE"] = "message";
    NotificationCategory["SYSTEM"] = "system";
    NotificationCategory["REMINDER"] = "reminder";
    NotificationCategory["ACHIEVEMENT"] = "achievement";
    NotificationCategory["ANNOUNCEMENT"] = "announcement";
    NotificationCategory["PLAN"] = "plan";
    NotificationCategory["RESOURCE"] = "resource";
})(NotificationCategory || (NotificationCategory = {}));
export var NotificationPriority;
(function (NotificationPriority) {
    NotificationPriority["LOW"] = "low";
    NotificationPriority["MEDIUM"] = "medium";
    NotificationPriority["HIGH"] = "high";
    NotificationPriority["URGENT"] = "urgent";
})(NotificationPriority || (NotificationPriority = {}));
//# sourceMappingURL=notification.enum.js.map